import { combineReducers } from 'redux';

import byPage from './byPage/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('queryString', combineReducers({ byPage }));



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/magazineArticles/byQuery/reducer.js
 **/